module.exports = __webpack_public_path__ + "img/eotg-1.57d4edb2.jpg";